import { v4 as uuidv4 } from "uuid"

const AUTH_CODES_KEY = "authCodes"

export const getStoredAuthCodes = (): string[] => {
  const raw = localStorage.getItem(AUTH_CODES_KEY)
  if (!raw) return []

  try {
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed)) {
      return parsed.filter((code): code is string => typeof code === "string")
    }
  } catch {
    // Ignore malformed storage and treat as empty.
  }

  return []
}

export const getOrCreateClientAuthCode = (): string => {
  const storedAuthCodes = getStoredAuthCodes()
  if (storedAuthCodes.length === 0) {
    const newClientAuthCode = uuidv4()
    localStorage.setItem(AUTH_CODES_KEY, JSON.stringify([newClientAuthCode]))
    return newClientAuthCode
  }

  return storedAuthCodes[storedAuthCodes.length - 1]
}
